import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon } from '@material-ui/icons'

import { BatchDialog } from 'src/modules/supply_chain/components/BatchDialog'
import { DateField, RelatedLinkedField, ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const BatchDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <BatchDialog
          open={updateOpen}
          batch={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Batch', onClick: () => setUpdateOpen(true) }],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'client', label: 'Client', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'batchType', label: 'Type', renderer: ValueField },
          { id: 'clientId', label: 'Number', renderer: ValueField },
          { id: 'expiresOn', label: 'Expires On', renderer: DateField },
          { id: 'asn', label: 'ASN', renderer: RelatedLinkedField(ValueField, 'name') },
        ]}
      />
    </>
  )
}
